<template>
  <div class="d-flex flex-column" style="background-color: #ffffff; min-height: 60vh; border: 1px solid #d0d0d0">
    <!-- Top nav -->
    <div
      class="d-flex align-center justify-space-between"
      style="padding: 24px; height: 104px; background-color: #ffffff"
    >
      <!-- Back -->
      <button
        class="d-flex align-center"
        style="gap: 8px; background: none; border: none; cursor: pointer; padding: 0"
        @click="handleBack"
      >
        <v-icon size="24">mdi-chevron-left</v-icon>
        <span
          style="
            font-family: Arial, sans-serif;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.48px;
            color: #000000;
            text-decoration: underline;
          "
        >
          Back
        </span>
      </button>

      <!-- Notifications + badge -->
      <div class="d-flex align-center" style="gap: 4px">
        <span
          style="
            font-family: Arial, sans-serif;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            letter-spacing: -0.6px;
            color: #000000;
          "
        >
          Notifications
        </span>
        <div
          v-if="notificationStore.unreadCount > 0"
          class="d-flex align-center justify-center flex-shrink-0"
          style="width: 24px; height: 24px; border-radius: 100px; background-color: #cc2f2f"
        >
          <span
            style="font-family: Arial, sans-serif; font-weight: 700; font-size: 12px; line-height: 18px; color: #ffffff"
          >
            {{ notificationStore.unreadCount }}
          </span>
        </div>
      </div>

      <!-- Collapse -->
      <button
        style="background: none; border: none; cursor: pointer; padding: 0; display: flex; align-items: center"
        @click="handleCollapse"
      >
        <v-icon size="24">mdi-arrow-collapse</v-icon>
      </button>
    </div>

    <!-- Announcements section -->
    <div
      class="d-flex flex-column flex-grow-1"
      style="background-color: #ffffff; border-top: 1px solid #d0d0d0; overflow: hidden"
    >
      <!-- Sub-header -->
      <div class="d-flex align-center justify-space-between" style="padding: 24px 24px 12px 24px">
        <span
          style="
            font-family: Arial, sans-serif;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            letter-spacing: -0.6px;
            color: #747474;
          "
        >
          Most recent
        </span>
        <button
          v-if="notificationStore.hasUnread"
          style="
            font-family: Arial, sans-serif;
            font-size: 14px;
            line-height: 18px;
            color: #000000;
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
          "
          @click="notificationStore.markAllAsRead()"
        >
          Mark all as read
        </button>
      </div>

      <!-- Notification list -->
      <div ref="scrollContainer" class="flex-grow-1" style="padding: 0 24px; overflow-y: auto">
        <div v-if="notifications.length === 0" class="d-flex align-center justify-center" style="padding: 48px 0">
          <span style="font-family: Arial, sans-serif; font-size: 16px; line-height: 24px; color: #747474">
            No notifications
          </span>
        </div>

        <template v-else>
          <div v-for="(notification, index) in notifications" :key="notification.id">
            <NotificationItem :notification="notification" />
            <div
              v-if="index < notifications.length - 1"
              style="height: 0; width: 100%; border-bottom: 1px solid #d0d0d0"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { useNotificationStore } from '@/stores/notifications';
import { DataLayerMixin } from '../../mixins/dataLayerMixin';
import NotificationItem from './NotificationItem.vue';

export default {
  name: 'NotificationFullScreen',
  mixins: [DataLayerMixin],
  components: { NotificationItem },
  setup() {
    const notificationStore = useNotificationStore();
    return { notificationStore };
  },
  data() {
    return {
      observer: null,
      pendingReadTimers: new Map()
    };
  },
  computed: {
    notifications() {
      return this.notificationStore.allNotifications;
    }
  },
  mounted() {
    this.$nextTick(() => this.initScrollObserver());
  },
  beforeUnmount() {
    this.cleanupObserver();
  },
  methods: {
    handleBack() {
      this.asuoDataLayerClick('accelerateDashboard', '39');
      this.notificationStore.panelExpanded = false;
      this.notificationStore.panelOpen = true;
    },
    handleCollapse() {
      this.asuoDataLayerClick('accelerateDashboard', '40');
      this.notificationStore.panelExpanded = false;
      this.notificationStore.panelOpen = true;
    },
    initScrollObserver() {
      this.cleanupObserver();

      const container = this.$refs.scrollContainer;
      if (!container) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const id = entry.target.dataset?.notificationId;
            if (!id) return;

            if (entry.isIntersecting && !this.notificationStore.readIds.has(id)) {
              this.pendingReadTimers.set(
                id,
                setTimeout(() => {
                  this.notificationStore.markAsRead(id);
                  this.pendingReadTimers.delete(id);
                }, 3000)
              );
            } else if (!entry.isIntersecting) {
              clearTimeout(this.pendingReadTimers.get(id));
              this.pendingReadTimers.delete(id);
            }
          });
        },
        {
          root: container,
          threshold: 0.8
        }
      );

      container.querySelectorAll('[data-notification-id]').forEach((el) => {
        this.observer.observe(el);
      });
    },

    cleanupObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.pendingReadTimers.forEach((timer) => clearTimeout(timer));
      this.pendingReadTimers.clear();
    }
  }
};
</script>
